import { useCollapsibleTextItem } from "@website/ui/collapsible-text/collapsible-text.hook";
import styles from "@website/ui/collapsible-text/collapsible-text.module.scss";
import { CollapsibleTextPropertiesType } from "@website/ui/collapsible-text/collapsible-text.types";
import { FC, memo } from "react";

const CollapsibleText: FC<CollapsibleTextPropertiesType> = (properties) => {
  const {
    regionProperties,
    descriptionProperties,
    collapsed,
    buttonProperties,
    collapsible
  } = useCollapsibleTextItem(properties);
  const {
    className,
    buttonClassName,
    direction,
    title,
    moreText,
    lessText,
    titleStyle,
    moreTextIcon,
    lessTextIcon,
    withMedia,
    collapsedClassName,
    disableScrollWhenCollapsed = false,
    isHtml = false
  } = properties;
  return (
    <div
      className={`${styles["item"]} ${withMedia ? styles["with-media"] : ""}`}
    >
      {title && <h2 className={`${titleStyle ?? styles["title"]}`}>{title}</h2>}
      <div
        {...regionProperties}
        className={`${collapsedClassName} ${styles["content"]}`}
        dir={direction}
      >
        {isHtml ? (
          <div
            className={`${styles["description"]} ${className} ${
              collapsed && disableScrollWhenCollapsed ? "overflow-hidden" : ""
            }`}
            dangerouslySetInnerHTML={{
              __html: String(descriptionProperties?.children)
            }}
          />
        ) : (
          <div
            {...descriptionProperties}
            className={`${styles["description"]} ${className}`}
          />
        )}
      </div>
      <button
        hidden={!collapsible}
        {...buttonProperties}
        className={`${styles["button"]} ${buttonClassName}`}
      >
        <span className={styles["button__txt"]}>
          {collapsed ? moreText || "نمایش بیشتر" : lessText || "نمایش کمتر"}
        </span>
        <span>{collapsed ? moreTextIcon : lessTextIcon}</span>
      </button>
    </div>
  );
};

const CollapsibleTextMemoized = memo(CollapsibleText, () => false);
export { CollapsibleTextMemoized as CollapsibleText };
